var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"list"},[_vm._t("list-items")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }